import { axiosInstance } from "../axiosInterceptor";

interface ProfileData {
  role?: string;
  email?: string;
  is_admin?: boolean;
  user?: { role?: string; email?: string };
  profile?: { role?: string; email?: string };
  edges?: { user?: { role?: string; email?: string } };
  data?: { role?: string; email?: string };
  [key: string]: unknown;
}

interface ProfileApiResponse {
  data: ProfileData;
}

export const fetchProfileInfo = async () => {
  const response = await axiosInstance.get<ProfileApiResponse>(`/profile/`);
  return response?.data?.data;
};
